import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 -7 12 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H11C11.5523 2 12 1.55228 12 1C12 0.447715 11.5523 0 11 0H1Z",
			fill: "currentColor",
			fillOpacity: .8
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 5C2 4.44772 2.44772 4 3 4H9C9.55229 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6H3C2.44772 6 2 5.55228 2 5Z",
			fill: "currentColor",
			fillOpacity: .8
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 9C4 8.44771 4.44772 8 5 8H7C7.55229 8 8 8.44771 8 9C8 9.55229 7.55228 10 7 10H5C4.44772 10 4 9.55229 4 9Z",
			fill: "currentColor",
			fillOpacity: .8
		})
	]
});
const ForwardRef = forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
